import { gql } from '@apollo/client';


export const CALL_CUSTOMER = gql`
  mutation callCustomer($userId: String!, $conversationId: String!) {
    callCustomer(userId: $userId, conversationId: $conversationId) {
      message
    }
  }
`;
